'use es6';

export var getIsReviewModalOpen = function getIsReviewModalOpen(state) {
  return state.reviewInputInfo.get('open');
};